import type { CmsImageType } from '@packages/cms-components/src/components/CmsImage/types';
import { useDeviceType } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import Image from 'next/image';

export type BannerItemImageProps = {
  data: CmsImageType;
};

export const BannerItemImage = ({
  data: {
    field_alternate_text: imageAlt,
    field_image_default: imageDefault,
    field_image_mobile: imageMobile,
    field_image_tablet: imageTablet,
  },
}: BannerItemImageProps) => {
  const { isMobile, isTablet } = useDeviceType();
  const {
    assets: {
      cmsImage: {
        imageOptimizationEnabled,
        uriTransformSource,
        uriTransformEndpoint,
        imageQuality,
      },
    },
  } = useConfig();

  const imageData = (isMobile && imageMobile) || (isTablet && imageTablet) || imageDefault;
  const imageDataWidth = !Array.isArray(imageData?.meta) && imageData?.meta?.width;
  const imageDataHeight = !Array.isArray(imageData?.meta) && imageData?.meta?.height;
  const imageUri =
    typeof imageData?.uri === 'object' && 'url' in imageData.uri && imageData.uri?.url !== ''
      ? imageData.uri?.url
      : null;
  const imageValue =
    typeof imageData?.uri === 'object' && 'value' in imageData.uri && imageData.uri?.value !== ''
      ? imageData.uri?.value
      : null;
  const useNextImage = imageUri && imageDataWidth && imageDataHeight;

  if (imageValue && imageUri && useNextImage) {
    return (
      <Image
        src={
          imageOptimizationEnabled
            ? imageValue.replace(uriTransformSource, uriTransformEndpoint)
            : imageUri
        }
        alt={imageAlt || ''}
        width={typeof imageDataWidth === 'number' ? imageDataWidth : parseInt(imageDataWidth, 10)}
        height={
          typeof imageDataHeight === 'number' ? imageDataHeight : parseInt(imageDataHeight, 10)
        }
        loading="lazy"
        {...(imageOptimizationEnabled ? { quality: imageQuality } : { unoptimized: true })}
      />
    );
  }

  if (imageUri) {
    return <img src={imageUri} alt={imageAlt || ''} loading="lazy" />;
  }

  return null;
};
